module.exports = __webpack_public_path__ + "html/relation-list_e602b4416f7737e019a86053a01fc3e0.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/relation-list.html
// module id = driL
// module chunks = 96